// Please respect the alphabetical order
export { default as DeliveryPage } from './Delivery';
export { default as InformationsPage } from './Informations';
export { default as OrderPage } from './Order';
export { default as ThanksPage } from './Thanks';
export { default as TrainingPage } from './Training';
export { default as WelcomePage } from './Welcome';



// WEBPACK FOOTER //
// ./src/pages/index.js